import MuiAvatar, { AvatarProps as MuiProps } from "@mui/material/Avatar";
import { PropsWithChildren, ReactElement, useMemo } from "react";

// TODO: Not sure this will be effective for all our supported languages
export const getInitials = (displayName: string): string => {
  if (!displayName) {
    return "";
  }

  const names = displayName
    .trim()
    .split(" ")
    .map((x) => x.trim())
    .filter((x) => x !== "");

  const lastIdx = names.length && names.length - 1;
  const firstInitial = names[0]?.charAt(0).toLocaleUpperCase() || "";

  return lastIdx ? `${firstInitial}${names[lastIdx].charAt(0).toLocaleUpperCase()}` : firstInitial;
};

export type AvatarProps = {
  /** The users full display name */
  displayName?: string;
} & MuiProps;

export const Avatar = ({
  displayName,
  children,
  ...avatarProps
}: PropsWithChildren<AvatarProps>): ReactElement => {
  const initials = useMemo(
    () => (displayName ? getInitials(displayName) : undefined),
    [displayName],
  );
  const imgProps: AvatarProps["imgProps"] = {
    referrerPolicy: "no-referrer",
    ...avatarProps?.imgProps,
  };

  return (
    <MuiAvatar {...avatarProps} imgProps={imgProps}>
      {initials || children || null}
    </MuiAvatar>
  );
};
